import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import nework from "../../../../../../../../src/assets/images/Souvenir/live.png";
import { serverInfo } from "../../../../../../../App";
import Finish from "../../../../../../../assets/images/finish.png";
import Clock from "../../../../../../../assets/images/meetupEvent/clock-icon.png";
import "./CricketJerseryAdmin.css";
import CricketJerseyModal from "./CricketJerseyModal";

const AdminBidding = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  const history = useHistory();
  const [modalShow, setModalShow] = React.useState(false);
  const [modalData, setModalData] = useState("");
  const [topBidders, setTopBidders] = useState([]);
  const [bidTime, setBidTime] = useState("");
  const [auction_id, setAuctionId] = useState();

  const bidEnd = new Date(bidTime);
  const nowTime = new Date();

  const openModal = (auction_id) => {
    setModalShow(true);
    setAuctionId(auction_id);
  };

  const { id } = useParams();
  const checkout = () => {
    history.push(`/superstar-admin/auction/live-biddings-checkout/${id}`);
  };

  const [product, setPendingProduct] = useState([]);
  const [bidding, setPendingBidding] = useState([]);

  useEffect(() => {
    axios.get(`/api/admin/show/auction/product/${id}`).then((res) => {
      if (res.status === 200) {
        setPendingProduct(res.data.product);
        setBidTime(res.data.product.bid_to);
      }
    });

    axios.get(`/api/admin/liveBidding/auction/${id}`).then((res) => {
      if (res.status === 200) {
        setPendingBidding(res.data.bidding);
      }
    });
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-6 mb-2">
          <div className="card card-bg p-2">
            <img
              src={imageCdnUrl + product.product_image}
              alt=""
              className="img-fluid banner-pro"
            />
          </div>
        </div>

        <div className="col-sm-12 col-md-12 col-lg-6 mb-2 row bidderScroll">
          {bidding.map((bidder) => (
            <div className="col-md-6 mb-1 ">
              <div className=" card card-bg p-2 ">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="col-3">
                    <img
                      src={imageCdnUrl + bidder.user?.image}
                      className="img-fluid"
                      alt=""
                      style={{
                        height: "50px",
                        width: "50px",
                        borderRadius: "50%",
                      }}
                    />
                  </div>
                  <div className="col-9">
                    <h5 className="mx-0 p-0 text-warning fw-bold">
                      $ {bidder.amount}
                    </h5>
                    <h6 className="mx-0 p-0  text-light fw-bold">
                      {bidder.user?.first_name} {bidder.user?.last_name}
                    </h6>
                    <small className="m-0 p-0  text-light">
                      {moment(bidder.created_at).format("YYYY MM DD")} |{" "}
                      {moment(bidder.created_at).format("HH:mm a")}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="row my-3">
        <div className="col-md-12">
          <div className="card card-bg shadow">
            <div className="card-body">
              <p className="text-light fs-5 ">
                {" "}
                <Markup content={product.title} />
              </p>
              <h5 className="text-light pb-3"> {product.name}</h5>

              <h5 className="text-warning">Description</h5>
              <div className="under-line"></div>
              <p className="text-light mt-2">
                <Markup content={product.details} />
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <div className="registration-body  card-bg m-0 pt-3">
            <div className="row mb-5 m-2">
              <div className="col-md-6 m-0 ">
                <div className="d-flex registration-btn p-2">
                  <div className="mx-3 mt-2">
                    <span className="text-light">
                      <img src={Finish} alt="" className="PriceTage" />
                    </span>
                  </div>
                  <div className=" mx-1">
                    <span className=" text-warning fw-bold">
                      <p className="text-warning fw-bold">
                        <h6>Last Date</h6>
                        {moment(product.bid_to).format("LL")}
                      </p>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-6 m-0 ">
                <div className="d-flex registration-btn p-2">
                  <div className="mx-3 mt-2">
                    <span className="text-light">
                      <img src={Clock} alt="" className="PriceTage" />
                    </span>
                  </div>
                  <div className=" mx-1">
                    <span className=" text-warning fw-bold">
                      <p className="text-warning fw-bold">
                        <h6>Time</h6>

                        {moment(product.bid_to).format("LT")}
                      </p>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-5 ">
        <div className="container-fluid">
          <div className="card card-admin-souviner">
            <div className="card-body">
              {product.star_approval != 2 ?
              <div className="container">
                <div className="my-4">
                  <div className="row my-4 d-flex justify-content-center">
                    <div className="col-md-3 mb-2">
                      <button
                        className="btn btnCreate w-100 fw-bold py-2 "
                        disabled={
                          bidEnd.getTime() > nowTime.getTime() ? true : false
                        }
                        onClick={() => openModal(product.id)}
                      >
                        Upfront payment
                      </button>
                    </div>

                    <div className="col-md-3 mb-2">
                      <button
                        className="btn btnUpdate w-100  fw-bold py-2 "
                        onClick={checkout}
                      >
                        Go to Checkout
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              :' '
              }
            </div>
          </div>
        </div>

        <CricketJerseyModal
          show={modalShow}
          onHide={() => setModalShow(false)}
          auction_id={auction_id}
        />
      </div>
    </div>
  );
};

export default AdminBidding;
